import { useState } from "react";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
//My Components
import AllProjects from "./tables/allProjectsTable";
import QuickStats from "./tables/quickStatTable";

function Projects() {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabType = (event, newValue) => {
    setActiveTab(newValue);
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />

      {/* Nav Tabs Here */}
      <Container>
        <Grid container item justifyContent="center" xs={12} lg={12} mx="auto">
          <AppBar position="static">
            <Tabs
              value={activeTab}
              onChange={handleTabType}
              // sx={{ backgroundColor: "grey" }}
              // textColor="primary"
              // indicatorColor="primary"
            >
              <Tab label="All Projects" sx={{ fontWeight: "bold" }} />
              <Tab label="Project Progress" sx={{ fontWeight: "bold" }} />
              <Tab label="Approved" sx={{ fontWeight: "bold" }} />
            </Tabs>
          </AppBar>
        </Grid>
      </Container>
      {/* Nav Tabs end Here */}

      <MDBox mb={2} />
      {/* {activeTab === 0 && <AllStudents />} */}
      {/* {activeTab === 1 && <ApprovedStudents />}
      {activeTab === 2 && <PendingStudents />} */}

      {activeTab === 0 && (
        <Grid container spacing={2}>
          <Grid item xs={12} md={8} lg={8}>
            <AllProjects />
          </Grid>
          <Grid item xs={12} md={4} lg={4}>
            <QuickStats />
          </Grid>
        </Grid>
      )}

      {/* {activeTab === 1 && <AllProgress />} */}
      {/* {activeTab === 2 && <ReportsTrial />} */}
      <MDBox mb={2} />

      <Footer />
    </DashboardLayout>
  );
}

export default Projects;
